import { useEditorWrappers } from '@components/App/Modal/BlockModal/hooks'
import type { ID } from '@octopus-do/octopus-project-core'
import {
  thunkUpdateSymbolContent,
  thunkUpdateSymbolTitle,
} from '@store/migrationActions/thunkActions/thunkSymbolActions'
import type { AppState } from '@store/types'
import { useDispatch } from 'react-redux'
import type { Action } from 'redux'
import type { ThunkDispatch } from 'redux-thunk'

export const useUpdateContent = (id: ID) => {
  const dispatch = useDispatch<ThunkDispatch<AppState, unknown, Action>>()

  // todo: fix different content type mapping
  const onChange = (next: unknown) => {
    dispatch(thunkUpdateSymbolContent({ id, content: next as string }))
  }

  const onRename = (next: string) => {
    dispatch(thunkUpdateSymbolTitle({ id, title: next }))
  }

  const { handleChange } = useEditorWrappers(id, onChange)

  return {
    onChange: handleChange,
    onRename,
  }
}
